import { useBackend } from "../../services";
import { useEffect, useState } from "react";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { DataStorage } from "../../models/DataStorage";

export const useGetHighlightedCollections = <T>(
  setLoading: (loading: boolean) => void,
  dependencies: T[] = []
) => {
  const { get } = useBackend();
  const storage = DataStorage.highlightedCollectionStorage;
  const [collections, setCollections] = useState(storage.getData(true, ""));
  useEffect(() => {
    if (collections && collections.length > 0) return;
    setLoading(true);
    get("collections/shared/highlights").then(({ body, status }) => {
      if (StatusCodesHelper.isSuccessful(status)) {
        setCollections(body);
        storage.setData(body, true, "");
      }
      setLoading(false);
    });
  }, dependencies);
  return collections;
};
